import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogSuggestionFooterOpenCommentWireframe from './VeltCommentDialogSuggestionFooterOpenCommentWireframe/VeltCommentDialogSuggestionFooterOpenCommentWireframe';
var VeltCommentDialogSuggestionFooterWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-footer-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionFooterWireframe.OpenComment = VeltCommentDialogSuggestionFooterOpenCommentWireframe;
export default VeltCommentDialogSuggestionFooterWireframe;
